import { useLocation } from "react-router";

import type { Area } from "./types.ts";

const AREA_SEGMENTS = new Set<Area>(["modules", "module-sets", "delivery", "settings"]);

// The active area is fully determined by the route, so derive it on render rather
// than mirroring it into state. Unrecognised segments fall back to "modules".
export const useActiveArea = (): Area => {
  const { pathname } = useLocation();
  const segment = pathname.slice(1).split("/")[0];
  return AREA_SEGMENTS.has(segment as Area) ? (segment as Area) : "modules";
};
